// Gate for the analytics debug panel, kept apart from the panel itself so the
// app shell can decide whether to load the panel's chunk without importing it.
//
// Turn the panel on with ?debug=analytics (sticks in localStorage) and off
// again with ?debug=off.
export const DEBUG_KEY = 'tasted_debug_analytics';

export function debugPanelEnabled() {
  if (typeof window === 'undefined') return false;
  try {
    const flag = new URLSearchParams(window.location.search).get('debug');
    if (flag === 'analytics') window.localStorage.setItem(DEBUG_KEY, '1');
    if (flag === 'off') window.localStorage.removeItem(DEBUG_KEY);
    return window.localStorage.getItem(DEBUG_KEY) === '1';
  } catch {
    return false;
  }
}
